'use client';

/**
 * POST /api/v1/enterprise/request-upgrade — in-app Enterprise/Corporate
 * upgrade request.  See enterprise-request.json.
 */
import { useMutation } from '@tanstack/react-query';

import { useApi } from '@/lib/api';

export interface EnterpriseRequestInput {
  requirements: string;
  team_size?: number;
  /** Annual budget in whole units of the edition's currency (USD here). The
   * deprecated `budget_inr` asserts rupees and the backend 400s it for a
   * global org (enterprise/requests.py::_resolve_budget), so it is not sent. */
  budget_amount?: number;
  /** May only agree with the edition's currency; sent so a mislabel 400s. */
  budget_currency?: 'USD';
  phone?: string;
}

export interface EnterpriseRequestResponse {
  id: string;
  org_id: string;
  user_id: string;
  request_type: 'in_app_request';
  full_name: string;
  email: string;
  company_name: string;
  phone: string | null;
  requirements: string;
  team_size: number | null;
  budget_amount?: number | null;
  budget_currency?: string | null;
  status: 'pending' | 'reviewing' | 'approved' | 'rejected';
  admin_notes: string | null;
  handled_by: string | null;
  handled_at: string | null;
  created_at: string;
}

export function useRequestEnterpriseUpgrade() {
  const api = useApi();
  return useMutation<EnterpriseRequestResponse, Error, EnterpriseRequestInput>({
    mutationFn: (body) =>
      api<EnterpriseRequestResponse>('/enterprise/request-upgrade', {
        method: 'POST',
        body,
      }),
  });
}
